import got from 'got';

class Dialex {
  key: string;
  url: string;

  constructor(key: string) {
    this.key = key;
    this.url = 'https://dialexherok.herokuapp.com';
  }

  transform(transformContent: string, lang: string): Promise<any> {
    const self = this;

    console.log(self.key);
    console.log(`${self.url}/api/v1/process`);

    return new Promise((resolve, reject) => {
      got('http://google.com').then(response => resolve(response.body)).catch(err => reject(err.message || err));
      // got(`${self.url}/api/v1/process`, {
      //   query: {
      //     apikey: self.key,
      //     data: transformContent,
      //     lang: lang
      //   }})
      //   .then(response => resolve(response.body))
      //   .catch(err => reject(err.message || err));
    });
  }
}

export default Dialex;



// WEBPACK FOOTER //
// ./src/Dialex.js